import { Component, ViewChild, OnInit, ViewEncapsulation, TemplateRef,  Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { saveAs } from 'file-saver';
import { ImageResult } from 'ngx-image2dataurl';
import { LocalStorage } from 'ngx-store';
import { ToastrService } from 'ngx-toastr';
import * as moment from "moment";
import {DaterangepickerDirective} from 'ngx-daterangepicker-material';

//Model
import { Tyre } from '../../../model/tyre.model';
import { Log, Url, User} from '../../../model/users.model';
import { ThemeSetting } from '../../../model/users.model';
import { FileExport } from '../../../model/exporter.model';

//Service
import { FilesService } from '../../../services/files.service';
import { ExportService } from '../../../services/exporter.service';
import { FleetAssetsService } from '../../../services/fleetassets.service';

@Component({
    selector: 'app-tyre',
    templateUrl: './tyre.component.html',
    styleUrls: ['../../datatable.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [FilesService, FleetAssetsService]
  })
  
  export class TyreComponent implements OnInit {
    @LocalStorage() url!: Url;
    @LocalStorage() user: User;
    @LocalStorage() themeSettings: ThemeSetting;

    public fileStoragePath = this.url.fileStorage;

    tyre_rows = [];
    
    drivers = [];
    fleet = [];
    providers = [];
    payment_statuses = [];

    selected = [];
    selected2 = [];
    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    isEditMode: boolean = false;

    public tyreForm: FormGroup;
    public modalRef: NgbModalRef;

    public tyre: Tyre;

    public frmFile: any;
    public fileExists :boolean;
    public fileRemove :boolean;
    public oldFile: string;

    public readonly prefixTyre = 'tyre';
    
    tyreYearly: number;
    tyreMonthly: number;
    tyreWeekly: number;
    tyreRecentCost: number;
    tyreRecentRego: string;
    tyreRecentDate: string;
    
    showDate:boolean=true;
    showRego:boolean=true;
    showFleetID:boolean=true;
    showSupplier:boolean=true;
    showCost:boolean=true;
    showReceiptNo:boolean=true;
    showFile:boolean=true;

    loadingIndicator2: boolean = true;
    public readonly prefixFleetAssets = "fleetassets";
    public readonly prefixFleetDetails = "fleetdetails";

    myDropDown='7';
    dateFilter='Last 7 Days';
  

    public tyreDateRange: any =[];
    locale: any = {
      format: 'DD MMMM YYYY',
      displayFormat: 'DD MMMM YYYY',
      separator: ' to ',
      cancelLabel: 'Cancel',
      applyLabel: 'OK',
    }
    maxDate: moment.Moment = moment();

    totalTyreAmount: any;
    totalTyre: number = 0;
    averageTyreAmount: any;

    public showSidebar : boolean = false;
    count: number;

    //Handles the name, type and content of the to-be exported file
    public exp_excel: FileExport;
    public exp_pdf: FileExport;
    
    //Stores the filtered and formatted content of the file
    formatted_list : any;
    spinner: boolean = false;

    @Input() tyres: Tyre[];
    @Input() parent: string;
    @Input() fleet_id :number; 
    @Output() refreshData : EventEmitter<any>= new EventEmitter<any>();
    @ViewChild('modalTyre', { static: false }) modalTyre: TemplateRef<any>;
    @ViewChild('modalDeleteTyre', { static: false }) modalDeleteTyre: TemplateRef<any>;
    @ViewChild(DaterangepickerDirective, {static: false}) daterangepicker: DaterangepickerDirective;

    driver_id:any;
    
    constructor(private http: HttpClient, private _fb: FormBuilder, private modal: NgbModal, private toastr: ToastrService,
      private fileService: FilesService, private fleetAssetsService: FleetAssetsService, private exporter: ExportService){


    }

    ngOnInit() {
        this.initTyreForm();
        this.resetFileVariables();
        this.getTyres(this.myDropDown);
        //Declaration to handle the name, type and content of the file
        this.exp_excel = {title:'', list_data:'', type:''};
        this.exp_pdf = {title:'', list_data:'', type:''};
    }
    
    tyre_columns = [
      { prop: 'id' },
      { prop: 'fleet_id' },
      { prop: 'driver_id' },
      { prop: 'provider_id' },
      { prop: 'tyre_description' },
      { prop: 'cost' },
      { prop: 'date_done' },
      { prop: 'time_done' },
      { prop: 'mileage' },
      { prop: 'fault' },
      { prop: 'receipt_no' },
      { prop: 'note' },
      { prop: 'file' },
      { prop: 'driver' },
      { prop: 'provider' },
      { prop: 'rego' },
      { prop: 'hours' },

    ];

    
    initTyreForm() {
      const intRegex = '^[1-9]{1,11}$';
      const currencyRegex = '^[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$';
      const floatRegex = '[+-]?([0-9]*[.])?[0-9]+';
      const numbers = '^[0-9]+$';
      this.tyreForm = this._fb.group({
        id: [''],
        fleet_id: ['', Validators.required ],
        driver_id: [''],
        provider_id: ['' , Validators.required],
        tyre_description: ['' , Validators.required],
        cost: ['' ,[Validators.required, Validators.pattern(currencyRegex)]],
        date_done: ['' , Validators.required],
        time_done: [''],
        time_string: [{hour: 1, minute: 30}],
        mileage: ['' ,[Validators.required, Validators.pattern(numbers)]],
        fault: ['' ],
        receipt_no: ['', Validators.required],
        note: [''],
        hours: ['' , [Validators.required, Validators.pattern(floatRegex)]],
        file: [''],
        user: [this.user.display_name] // needed for logs

    });
    }

    isCost() {
		const frmCtrl = (<any>this.tyreForm);

		if (frmCtrl.controls.cost.valid)
			return true;
		else return false;
    } 

    isHour() {
		const frmCtrl = (<any>this.tyreForm);

		if (frmCtrl.controls.hours.valid)
			return true;
		else return false;
    } 

    isMileage() {
		const frmCtrl = (<any>this.tyreForm);

		if (frmCtrl.controls.mileage.valid)
			return true;
		else return false;
    } 

    onSelect2({ selected2 }) {
      console.log('Select Event', selected2, this.selected2);
    }
  
    onActivate2(event2) {
      console.log('Activate Event', event2);
    }

    openTyreModal(tyre: Tyre): void {

      if(tyre){
        this.isEditMode = true;
        this.tyre = tyre;
        this.tyre['time_string'] = {hour: this.tyre['hour'], minute: this.tyre['minute']};
      

        this.tyreForm.patchValue(this.tyre);
        this.tyreForm.controls.user.setValue(this.user.display_name);

        

        if (this.tyre.file != null && this.tyre.file != '')
        {
          //console.log(this.tyre.file);
          this.oldFile = this.tyre.file;
          this.fileExists = true;
        }
      } 
      else{
        this.isEditMode = false;
        this.tyre = new Tyre();
        this.tyreForm.reset();
        this.tyreForm.controls.user.setValue(this.user.display_name);

         //fleet_id is preset if come from fleetdetails component
         var fleet_value = '';
         if(this.fleet_id){fleet_value = this.fleet_id.toString();};
         this.tyreForm.controls.fleet_id.setValue(fleet_value);
      }   
      this.modalRef = this.modal.open(this.modalTyre, { size: 'lg', backdrop: 'static'});
    
      this.modalRef.result.then((result) => {
        this.tyreForm.reset();
      }, (reason) => {
        this.tyreForm.reset();
      });
    }
    
    openDeleteTyreModal(tyre: Tyre) {
      if(tyre){
        this.tyre = tyre;
      } 
      this.modalRef = this.modal.open(this.modalDeleteTyre, { size: 'sm', backdrop: 'static'});
    }
    
    public getTyres (myDropdown,start='', end=''){
      setTimeout(() => { }, 100);
      if (!this.fleet_id) {
        this.fleetAssetsService.getTyres(myDropdown,start, end).subscribe(data=> {
          this.tyres = data['tyres'];
          if (typeof this.tyres != "undefined"  && this.tyres != null  
          && this.tyres.length != null  && this.tyres.length > 0) {
            this.selected = [this.tyres[0]];
          }  
          else{
            this.selected=[];
          }
          this.tyreYearly = data['tyre_yearly'];
          this.tyreMonthly = data['tyre_monthly'];
          this.tyreWeekly = data['tyre_weekly'];
          this.tyreRecentCost = data['tyre_recent_cost'];
          this.computeTyreSubtotals(); 
          this.count = Object.keys(this.tyres).length;
          if( data['tyre_recent_rego'] !== null){
            this.tyreRecentRego = data['tyre_recent_rego']['fleet_id_num'] + '(' + data['tyre_recent_rego']['rego']  + ')';
          }else{ this.tyreRecentRego = '-';};
          this.tyreRecentDate = data['tyre_recent_date'];
          this.fullRowsTyre = this.tyres;

          setTimeout(() => { this.loadingIndicator2 = false; }, 100);
        });
      }
      else {
        this.fleetAssetsService.getTyresByFleetId(this.fleet_id.toString(),myDropdown,start,end).subscribe(data=> {
          this.tyres = data['tyres'];
          this.computeTyreSubtotals(); 
          this.fullRowsTyre = this.tyres;
          if (typeof this.tyres != "undefined"  && this.tyres != null  
          && this.tyres.length != null  && this.tyres.length > 0) {
              this.selected = [this.tyres[0]];
          }  
          else{
            this.selected=[];
          }
          setTimeout(() => { this.loadingIndicator2 = false; }, 100);
        });
        this.getTyreDashboard();
      }



        this.fullRowsTyre = this.tyres;
        this.tempTyre = this.tyres;
          
        this.http.get(this.url.rest + '/tms/getFleetAssetsMisc').subscribe(data => {
        
            this.drivers = data["drivers"];
            this.fleet = data['fleet'];
            //this.providers = data['providers'];
            this.payment_statuses = data['payment_statuses'];
    
            setTimeout(() => { 
              this.loadingIndicator2 = false; 
             }, 100);
            
        });

        this.fleetAssetsService.getProvidersTyre().subscribe(data =>{
          this.providers = data['providers'];
        });

    }

    onChangeofOptions(selected) {
      console.log('changing to', selected);
      if (selected == 'week') {
          this.myDropDown =  'week'
          this.dateFilter = 'This Week'
          this.showFilters = false;
          this.getTyres(this.myDropDown);
      }
      else
      if (selected == 'month') {
          this.myDropDown =  'month'
          this.dateFilter = 'Month'
          this.showFilters = false;
          this.getTyres(this.myDropDown);
      }
      else 
      if (selected == 'year') {
          this.myDropDown =  'year'
          this.dateFilter = 'This Year'
          this.showFilters = false;
          this.getTyres(this.myDropDown);
      }
      else
      if (selected == 'today') {
          this.myDropDown =  'today'
          this.dateFilter = 'Today'
          this.showFilters = false;
          this.getTyres(this.myDropDown);
      }
      else
      if (selected == '7') {
          this.myDropDown =  '7'
          this.dateFilter = 'Last 7 Days'
          this.showFilters = false;
          this.getTyres(this.myDropDown);
      }
      else
      if (selected == '14') {
          this.myDropDown =  '14'
          this.dateFilter = 'Last 14 Days'
          this.showFilters = false;
          this.getTyres(this.myDropDown);
      }
      else
      if (selected == '30') {
          this.myDropDown =  '30'
          this.dateFilter='Last 30 Days'
          this.showFilters = false;
          this.getTyres(this.myDropDown);
      }
      else
      if (selected == '90') {
          this.myDropDown =  '90'
          this.dateFilter = 'Last 90 Days'
          this.showFilters = false;
          this.getTyres(this.myDropDown);
      }
      else
      if (selected == 'range') {
          this.myDropDown =  'range'
          this.dateFilter = 'Custom'
          this.showFilters = true;
          // this.getTyres(this.myDropDown);
          this.processTyreDateRange('');
      }
      else if(selected == "all"){
        this.showFilters = true;
        this.getTyres("");
      }
    }

    processTyreDateRange(event) {
      console.log('processing range');
      // if (this.tyreDateRange.start != undefined && this.tyreDateRange.end != undefined){
      var start = moment(this.tyreDateRange.start?._d).format('YYYY-MM-DD');
      var end = moment(this.tyreDateRange.end?._d).format('YYYY-MM-DD');
      console.log("START",start + ' to ' + end);
      this.getTyres('range',start, end);
      // }
    }

    computeTyreSubtotals() {
      this.totalTyreAmount = 0;
      this.totalTyre = 0;
      if (this.tyres[0]) {
          let sum: number = this.tyres.map(a => a.cost).reduce(function(a, b)
          {
          return a + b;
          });
          this.totalTyreAmount = sum;

          this.totalTyre = this.tyres.length;
      }
      this.averageTyreAmount = (this.totalTyreAmount / this.totalTyre) || 0;
    }

    public getTyreDashboard(){
      if(this.parent == this.prefixFleetDetails){
        console.log("fetching tyre dashboard data");
        this.fleetAssetsService.getTyreSummaryByFleetId(this.fleet_id).subscribe(data=>{
            console.log('getting dash data by fleet id:', data);
            this.tyreYearly = data['tyre_yearly'];
            this.tyreMonthly = data['tyre_monthly'];
            this.tyreWeekly = data['tyre_weekly'];
            this.tyreRecentCost = data['tyre_recent_cost'];
            if( data['tyre_recent_rego'] !== null){
              this.tyreRecentRego = data['tyre_recent_rego']['fleet_id_num'] + '(' + data['tyre_recent_rego']['rego']  + ')';
            }else{ this.tyreRecentRego = '-';};
            this.tyreRecentDate = data['tyre_recent_date'];
            setTimeout(() => { this.loadingIndicator2 = false; }, 100);
        });
      }
    }

    public createTyre(tyre: Tyre) {
      this.spinner = true;
        this.fleetAssetsService.createTyre(tyre).subscribe(tyre => {
            this.refreshData.emit();
            this.getTyres(this.myDropDown);   
        });
        this.spinner = false;
    }

    async updateTyre(tyre:Tyre) {
      this.spinner = true;
        await this.fleetAssetsService.updateTyre(tyre).toPromise().then(result=> {
            this.toastr.success('', result['message'], {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
            }); 
                
        }).catch(err =>{
            this.toastr.error("Please try again.", "There was a problem with updating the selected tyre entry.", {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
          }).finally(() => {
            this.refreshData.emit(); 
          });
        this.getTyres(this.myDropDown);
        console.log('updated tyres');
        this.spinner = false;
    }

    async deleteTyre(tyre : Tyre) {
      
        this.spinner = true;
        if(tyre.file != null && tyre.file != ''){
        this.deleteFile(this.prefixTyre, tyre.file);
        }

        await this.fleetAssetsService.deleteTyre(tyre.id).toPromise().then(result => {
            this.toastr.success('', result['message'], {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
              });
            
        }).catch(err =>{
            this.toastr.error("Please try again.", "There was a problem with deleting the selected tyre.", {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
          }).finally(() => {
            this.refreshData.emit();
            this.getTyres(this.myDropDown); 
          });
        this.modalRef.close();
        this.spinner = false;
    }

  
    public closeModal(){
        this.modalRef.close();
        this.spinner = false;
        this.ngOnInit();
    }

    async onSubmitTyre(tyre: any) {
      if(this.verifyDateValues()){
        this.spinner = true;
        this.tyre = tyre;
        if (this.tyre.time_string != null)
        {
          this.tyre['time_done'] = this.tyre['time_string'].hour + ":" + this.tyre['time_string'].minute + ":00";
        }
        else{
          this.tyre['time_done'] = '00:00:00'
        }

        if (this.tyreForm.valid) {
        this.tyre = tyre;
        if(tyre.id){
            this.updateTyre(this.tyre);
            console.log('updating tyre...');
        }
        else{
            console.log('creating tyre...');
            await this.fleetAssetsService.createTyre(tyre).toPromise().then(result => {
                console.log("Result101",result)
                this.toastr.success('', result['message'], {
                    timeOut: 5000,
                    positionClass: 'toast-top-full-width',
                    progressBar: true
                  });
                
            }).catch(err =>{
                this.toastr.error("Please try again.", "There was a problem with creating new tyre entry.", {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
                });
            }).finally(() => {
                this.refreshData.emit();
            });
        }   
        this.getTyres(this.myDropDown);  
        this.uploadFile(this.prefixTyre, this.tyre.file);
        this.closeModal();       
        }
      }
      else this.showInvalidDateToastr();
    }

  verifyDateValues(){
    if( (this.tyreForm.value.date_done != "" && !moment(this.tyreForm.value.date_done, "YYYY-MM-DD", true).isValid()) ){
        return false;
    }
    else return true;
  }

  showInvalidDateToastr(){
    this.toastr.error('', 'Entered an invalid date!', {
        timeOut: 2000,
        positionClass: 'toast-top-full-width',
        progressBar: true
    });
  }

    public getFile(event, caller){

        var assetFilename;

        if (event == '' || event == null){
        assetFilename = event
        }else{
        var file : ImageResult;
        file = event;
        assetFilename =  file.file.name;

        this.frmFile = event;
        }

        switch (caller){
        case this.prefixTyre: 
            { this.tyreForm.controls.file.setValue(assetFilename); break;};
        default: break;
        }
    }

    public uploadFile(caller, filename){
        if (this.frmFile){
        this.fileService.uploadRawFile(caller, this.frmFile, filename).subscribe(file=>{
            console.log('file uploaded....');
        });
        
        }

        this.frmFile = '';

        //handling files if replaced, old file is removed from server
        if(this.fileRemove == true){
            this.deleteFile(caller, this.oldFile);
        };
    }

    public removeFile(caller){
        this.fileExists  = false;

        switch (caller){
        case this.prefixTyre:
            { this.tyreForm.controls.file.setValue(''); break;};
        default: break;
        }
        
        this.fileRemove = true;
    }

    public deleteFile(caller, filename){
        this.fileService.deleteFile(caller, filename).subscribe(result=>{console.log(result);})
        this.fileRemove = false;   
    }

    public resetFileVariables(){
        // for document file handling variables; checking if file exists or removed
            this.fileExists = false;
            this.fileRemove  = false;
            this.oldFile = '';
    }

    public isNumber(value) {
        if (isNaN(value) ) {
        return false;
        }
        else return true;
    }

    print(caller: string): void {
        let printContents, popupWin;
        printContents = document.getElementById('print-section-' + caller).innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
        <html>
        <head>
        <title>Tyre Assets</title>
        <style>
        @page {
            size: A4;
        }

        table {
            border-collapse: collapse;
            border-spacing: 0;
            width: 100%;
            border: 1px solid #ddd !important;
        }

        th, td {
            text-align: left;
            padding: 16px;
        }


        tr:nth-child(even) {
            background-color: #f2f2f2 !important;
            box-shadow: inset 0 0 0 1000px #f2f2f2;
        }

        .fn {
        float: footnote;
        }

        thead {
        box-shadow: inset 0 0 0 1000px #f2f2f2;
        }
        
            
        </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
        </html>`
        );
        popupWin.document.close();
    }

    public toggleFilters() {
        if (this.showFilters) this.showFilters = false;
        else this.showFilters = true;
    }

    toggleSideBar(){
      if(this.showSidebar== false){
        this.loadingIndicator = true;
        this.showSidebar = true;
        setTimeout(() => { this.loadingIndicator = false; }, 100);
      }else{
        this.loadingIndicator = true;
        this.showSidebar = false;
        setTimeout(() => { this.loadingIndicator = false; }, 100);
      }
      this.getTyres(this.myDropDown);
    }

  //Filter Codes

    showFilters: boolean = false;
    filterTyreRego: string = '';
    filterTyreProvider: string = '';
    filterTyreDateFrom: Date;
    filterTyreDateTo: Date;
    isFilterEmpty: boolean = true;
    tempTyre = [];
    fullRowsTyre = [];
    tyreCount = 0;
    summaryCount = 0;
    summaryTotalCost = 0;



    updateFilter(caller:string) {
        this.isFilterEmpty = false;

        switch (caller){
        case this.prefixTyre :{
            this.tempTyre = this.fullRowsTyre.filter(data => { 
            if (data.rego && this.filterTyreRego){
                return data.rego.toLowerCase().indexOf(this.filterTyreRego.toLowerCase()) !== -1 || !this.filterTyreRego.toLowerCase();      
            }else{
                return data.rego
            };
            });

            this.tempTyre = this.tempTyre.filter(data => { 
            if (data.provider_id && this.filterTyreProvider){
                return data.provider_id == this.filterTyreProvider;
            }else{
                return data.provider_id
            };
            });

            this.getTyresSummary(this.tempTyre)
            this.tyres = this.tempTyre;
            this.tyreCount = Object.keys(this.tempTyre).length;
            if(this.tyres.length>0){
              this.selected = [this.tyres[0]]
            }else{
                this.selected = [];
            }

            this.totalTyreAmount = 0;
            this.totalTyre = 0;
            if (this.tyres[0]) {
              let sum: number = this.tyres.map(a => a.cost).reduce(function(a, b){
                return a + b;
              });
              this.totalTyreAmount = sum;

              this.totalTyre = this.tyres.length;
            }

            this.averageTyreAmount = (this.totalTyreAmount / this.totalTyre) || 0;
        }
        default: {break;}
        }
    }

    public resetFilters() {
        this.filterTyreRego = '';
        this.filterTyreDateFrom = null;
        this.filterTyreDateTo = null;
        this.filterTyreProvider = '';
        this.isFilterEmpty = true;

        this.tyres = this.fullRowsTyre;
        this.summaryCount = 0;
        this.summaryTotalCost = 0;
        this.tyreDateRange=[];
        this.getTyres(this.myDropDown)
    }

    public getTyresSummary(tempTyre){
      this.summaryTotalCost = 0; this.summaryCount = 0;
      if(tempTyre.length === this.fullRowsTyre.length){
        this.summaryTotalCost = 0;
        this.summaryCount = 0;    
        console.log('full rows')
      } else {
        for(let i = 0; i < tempTyre.length; i++){
          this.summaryTotalCost = this.summaryTotalCost + tempTyre[i].cost;
        }
        console.log('temp rows')
        this.summaryCount = tempTyre.length;
      }
    }

      /*** Export... Module ***/
  //Replaces an attribute name for reading comprehension
  renameKey( obj, oldKey, newKey ) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  }

  //Formats readable header names in the given table
  generateHeaders(list_fleetAsset): any{
      const arr = JSON.parse(list_fleetAsset);
      arr.forEach( obj => {
      this.renameKey( obj, 'date_done', 'Date Done' );
      this.renameKey( obj, 'rego', 'REGO' );
      this.renameKey( obj, 'fleet_id_num', 'Fleet ID' );
      this.renameKey( obj, 'provider', 'Supplier' );
      this.renameKey( obj, 'cost', 'Cost' );
      this.renameKey( obj, 'receipt_no', 'Receipt No' );
      this.renameKey( obj, 'file', 'File' );
      });
      const updatedJson = JSON.stringify( arr );
      return updatedJson;
  }

  //Filters every column in the Tyre table list
  tyre_generateColumnsWithFilter(list_tyre){
      const arr = JSON.parse(JSON.stringify(list_tyre));
      arr.forEach( obj => {

          obj['date_done'] = formatDate(obj['date_done'], 'dd MMM yyyy', 'en_US');

          //remove filtered columns
          if(!this.showDate){
              delete obj['date_done'];
          };
          if(!this.showRego){
              delete obj['rego'];
          };
          if(!this.showFleetID){
              delete obj['fleet_id_num'];
          };
          if(!this.showSupplier){
              delete obj['provider'];
          };
          if(!this.showCost){
              delete obj['cost'];
          };
          if(!this.showReceiptNo){
            delete obj['receipt_no'];
        };
          if(!this.showFile){
              delete obj['file'];
          };
          delete obj['id'];
          delete obj['tyre_description'];
          delete obj['minute'];
          delete obj['hour'];
          delete obj['hours'];
          delete obj['note'];
          delete obj['mileage'];
          delete obj['driver'];
          delete obj['time_done'];
          delete obj['provider_id'];
          delete obj['fleet_id'];
          delete obj['fault'];
          delete obj['driver_id'];
      });
      const updatedJson = JSON.stringify( arr );
      return updatedJson;                         
  }

  //Exports Tyre table to CSV file
  tyre_exportToCSV(){
      if(this.tyres.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.tyre_generateColumnsWithFilter(this.tyres);

          //generate json with format header
          this.formatted_list = this.generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let csv_file = '[TMS]Fleet_Asset_Tyres_' + this.formattedDate(current_date);
          this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Fleet Asset - Tyres');
      }
  };

  //Exports Tyre table to PDF file
  tyre_exportToPDF(){
    if(this.tyres.length >0){
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.tyre_generateColumnsWithFilter(this.tyres);

      //generate json with format header
      this.formatted_list = this.generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let pdf_file = '[TMS]Fleet_Asset_Tyres_' + this.formattedDate(current_date);
      this.exp_pdf.title = 'FLEET TYRES';
      this.exp_pdf.type = 'pdf';
      this.exp_pdf.list_data = this.formatted_list;
      this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
        saveAs(data, pdf_file + '.' + this.exp_pdf.type);
      });
    }
  };

  //Exports Tyre table to MS Excel file
  tyre_exportToExcel(){
      if(this.tyres.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.tyre_generateColumnsWithFilter(this.tyres);

          //generate json with format header
          this.formatted_list = this.generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let excel_file = '[TMS]Fleet_Asset_Tyres_' + this.formattedDate(current_date);
          this.exp_excel.title = 'FLEET TYRES';
          this.exp_excel.type = 'xlsx';
          this.exp_excel.list_data = this.formatted_list;
          this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
              console.log(data);
              saveAs(data, excel_file)

              //var xlsx_file = new File(data, excel_file, {type: 'xlsx'});
              //saveAs(xlsx_file);

          });
      }
  }; 

  //Returns a date format in the file name
  public formattedDate(d = new Date) {
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());
  
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
  
    return `${day}/${month}/${year}`;
  }

} 



// end component